/**
 * Adds .scrolled class to .header-wrapper when page is scrolled past threshold.
 * Used to transition from transparent to opaque header.
 */
(function () {
  var header = document.querySelector('.header-wrapper');
  if (!header) return;

  var threshold = 80;

  function onScroll() {
    if (window.scrollY > threshold) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
